import type { Announcement } from "./announcement";

/**
 * Every platform announcement, oldest first.
 *
 * Publishing news is one entry here plus its copy under
 * `announcements.items.<id>` in both locales. Never reuse or rename an id:
 * therapists who acknowledged the old one would see the new one as unseen,
 * or never see it at all.
 */
export const ANNOUNCEMENTS: readonly Announcement[] = [
    {
        id: "emdr-bilateral-stimulation",
        publishedAt: "2026-10-08",
        expiresAt: "2027-01-08",
        icon: "sparkles",
        // The "where" lines are not optional: a therapist who works in person
        // would otherwise read "EMDR in AlchelyMeeting" and pass it by.
        highlights: ["call", "room", "ratings", "start"],
    },
];
